import React from "react";
import Dropdown from "react-bootstrap/Dropdown";

const AppDropDown = ({ menuItems = [], onSelect, name = "" }) => {
  return (
    <Dropdown>
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        {name || "Dropdown Button"}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {menuItems.map((item, idx) => (
          <Dropdown.Item
            eventKey={item?.key}
            key={idx}
            onClick={() => onSelect(item)}
          >
            {item?.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default AppDropDown;
